import { CardSection } from '../Card/CardSection.js';
import { themed } from '@indeed/ifl-css';

const CheckboxCardHeader = /*#__PURE__*/themed(CardSection, process.env.NODE_ENV === "production" ? {
  target: "elcmul80"
} : {
  target: "elcmul80",
  label: "CheckboxCardHeader"
})(() => ({}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94Q2FyZEhlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR2tDIiwiZmlsZSI6IkNoZWNrYm94Q2FyZEhlYWRlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDYXJkU2VjdGlvbiwgQ2FyZFNlY3Rpb25Db21wb25lbnQgfSBmcm9tIFwiLi4vQ2FyZC9DYXJkU2VjdGlvblwiO1xuaW1wb3J0IHsgdGhlbWVkIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5leHBvcnQgY29uc3QgQ2hlY2tib3hDYXJkSGVhZGVyID0gdGhlbWVkKFxuICBDYXJkU2VjdGlvbixcbiAge31cbikoKCkgPT4gKHt9KSkgYXMgQ2FyZFNlY3Rpb25Db21wb25lbnQ7XG5cbkNoZWNrYm94Q2FyZEhlYWRlci5kaXNwbGF5TmFtZSA9IFwiQ2hlY2tib3hDYXJkSGVhZGVyXCI7XG4iXX0= */");
CheckboxCardHeader.displayName = "CheckboxCardHeader";

export { CheckboxCardHeader };
